const hide = (t: HTMLElement) => {
  t.classList.add('d-none');
  t.classList.remove('d-block');
  t.querySelectorAll('.js-required-if-shown').forEach((t) =>
    t.removeAttribute('required'),
  );
};
const show = (t: HTMLElement) => {
  t.classList.add('d-block');
  t.classList.remove('d-none');
  t.querySelectorAll('.js-required-if-shown').forEach((t) =>
    t.setAttribute('required', ''),
  );
};

const adjustDependent = (prefix: string) => (src: HTMLSelectElement) => {
  const c = prefix + src.value.toLowerCase();
  document.querySelectorAll<HTMLElement>(`.${c}`).forEach(show);
  document
    .querySelectorAll<HTMLElement>(`[class*=${prefix}]:not(.${c})`)
    .forEach(hide);
};

(
  [
    ['select[name=country]', adjustDependent('js-country-')],
    ['select[name=subject_relation]', adjustDependent('js-subject-relation-')],
    [
      'input[name=power_of_attorney_proof]',
      (t: HTMLInputElement) => {
        t.setCustomValidity(
          (t.files?.[0]?.size ?? 0) > 3 * 1024 * 1024
            ? 'Exceeds 3MB size limit'
            : '',
        );
        t.reportValidity();
      },
    ],
  ] as [string, (t: HTMLSelectElement) => void][]
).forEach(([sel, f]): void => {
  const t = document.querySelector<HTMLSelectElement>(sel);
  if (!t) {
    console.warn(`No element found for selector ${sel}`);
    return;
  }
  t.addEventListener('change', () => f(t));
  f(t);
});
